import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { Nav, Navbar, Offcanvas } from "react-bootstrap";
import "./Header.scss";


function Header() {

  const [scroll, setScroll] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('home');

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 100);
    });
  },);

  const handleLinkClick = (linkName) => {
    setActiveLink(linkName);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.section');
      let activeSectionIndex = sections.length - 1;
      for (let i = 0; i < sections.length; i++) {
        if (window.scrollY + 200 < sections[i].offsetTop) {
          activeSectionIndex = i - 1;
          break;
        }
      }

      const links = document.querySelectorAll('.link-menu');
      links.forEach((link, index) => {
        if (index === activeSectionIndex) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);


  return (
    <>
      <div className='top-header'>
        <header className={`my-navbar ${scroll && "fixed"}`}>

          {["lg"].map((expand) => (
            <Navbar collapseOnSelect key={expand} expand={expand}>
              <div className='container'>
                <Navbar.Brand>
                  <Link className="headerlogo" to="/">
                    <img className="logo_home" src="/images/byp_logo.png" alt="" />
                  </Link>
                </Navbar.Brand>
                <Navbar.Toggle onClick={() => setMenuOpen(!isMenuOpen)} aria-controls={`offcanvasNavbar-expand-${expand}`} />

                <div className="navbar_main_header">
                  <Navbar.Offcanvas
                    id={`offcanvasNavbar-expand-${expand}`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                    placement="end"
                    show={isMenuOpen}
                    onHide={closeMenu}
                  >
                    <Offcanvas.Header closeButton> </Offcanvas.Header>

                    <Offcanvas.Body className="align-items-center justify-content-end">
                      <Nav className="navbar-menu-top">
                        <a href='#home' className={`link-menu ${activeLink === 'home' ? 'active' : ''}`} onClick={() => handleLinkClick('home')}>
                          <span>Home</span>
                        </a>
                        {/* <a href='#about-us' className={`link-menu ${activeLink === 'about-us' ? 'active' : ''}`} onClick={() => handleLinkClick('about-us')}>
                          <span>About Us</span>
                        </a> */}
                        <a href='#key-features' className={`link-menu ${activeLink === 'key-features' ? 'active' : ''}`} onClick={() => handleLinkClick('key-features')}>
                          <span>Key Features</span>
                        </a>
                        <a href='#download-app' className={`link-menu ${activeLink === 'download-app' ? 'active' : ''}`} onClick={() => handleLinkClick('download-app')}>
                          <span>Download App</span>
                        </a>
                        <a href='#contact-us' className={`link-menu ${activeLink === 'contact-us' ? 'active' : ''}`} onClick={() => handleLinkClick('contact-us')}>
                          <span>Contact us</span>
                        </a>
                        {/* <NavLink className="link-menu" to="/home"></NavLink>
                        <NavLink className="link-menu" to="/about_section">About Us</NavLink>
                        <NavLink className="link-menu" to="/key-features">Key Features</NavLink>
                        <NavLink className="link-menu" to="/download-app">Download App</NavLink>
                        <NavLink className="link-menu" to="/contact-us">Contact us</NavLink> */}
                      </Nav>
                    </Offcanvas.Body>
                  </Navbar.Offcanvas>
                </div>
              </div>
            </Navbar>
          ))}
        </header>
      </div>
    </>
  )
}

export default Header